import Module from '../../utils/modules/Module'

export default class GreenBannerModule extends Module {
  constructor (options) {
    super(options)
    this.onResize = this.onResize.bind(this)
    
    this.DOMEl = options.element;
    this.paragraph = this.DOMEl.querySelector(".text-banner")
    this.init();

    this.onResize();
  }

  onResize() {
    const textHeight = this.paragraph.getBoundingClientRect().height;

    document.documentElement.style.setProperty('--height-text-banner', textHeight + "px");
  }

  init () {

    window.addEventListener('resize', this.onResize)

    const observer = new IntersectionObserver( 
      ([e]) => e.target.classList.toggle('is-sticky', e.intersectionRatio < 1),
      {
        rootMargin: '-59px 0px 0px 0px',
        threshold: [1]
      }
    );

    observer.observe(this.DOMEl)
  }
}
